'use client'

import { Dialog } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { clickEvent } from '_libs/common/event-tracker/events'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { Screen } from 'constants/tracking/screens'

type Props = {
  isOpen: boolean
  transactionId?: number
  onSubmit: () => void
  onClose: () => void
}

const ConfirmParcelSentModal = ({ isOpen, transactionId, onSubmit, onClose }: Props) => {
  const { track } = useTracking()
  const translate = useTranslate('conversation.confirm_parcel_sent_modal')

  function trackSubmitClick() {
    if (!transactionId) return

    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        screen: Screen.MessageReply,
        target: ClickableElement.ConfirmMarkTransactionAsShipped,
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  function handleSubmit() {
    trackSubmitClick()
    onSubmit()
  }

  return (
    <Dialog
      title={translate('title')}
      body={translate('body')}
      actions={[
        {
          text: translate('actions.confirm'),
          style: Dialog.ActionStyling.Filled,
          callback: handleSubmit,
        },
        {
          text: translate('actions.close'),
          style: Dialog.ActionStyling.Flat,
          callback: onClose,
        },
      ]}
      show={isOpen}
    />
  )
}

export default ConfirmParcelSentModal
